/**
 * HoroscopeFeed — renders the server-driven list of widgets.
 *
 * Extracted from HoroscopePage so the page reads as a clean two-way switch
 * (astro form vs feed). Pure presentation: it maps `items` through
 * WidgetRenderer, full-bleeding the banner and side-padding the rest, and shows
 * the "being prepared" state when there's nothing to render.
 */
import { HoroscopeItem } from '../api/types'
import { WidgetRenderer } from './WidgetRenderer'
import { PageState } from './PageState'

export function HoroscopeFeed({ items }: { items: HoroscopeItem[] }) {
  if (items.length === 0) {
    return (
      <div className="px-4">
        <PageState>Your horoscope is being prepared.</PageState>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4 pb-4">
      {items.map((item) =>
        // Banner is full-bleed (matches the 360-wide design); others get side padding.
        item.type === 'BANNER_IMAGE' ? (
          <WidgetRenderer key={item.id} item={item} />
        ) : (
          <div key={item.id} className="px-4">
            <WidgetRenderer item={item} />
          </div>
        )
      )}
    </div>
  )
}

export default HoroscopeFeed
